import AdConsole from './Adconsole.tsx';
import Facebook from './Facebook.tsx';
import Gitlab from './Gitlab.tsx';
import Google from './Google.tsx';
import Instagram from './Instagram.tsx';
import Linkedin from './Linkedin.tsx';
import Meta from './Meta.tsx';
import Microsoft from './Microsoft.tsx';
import Passendo from './Passendo.tsx';
import Semantiq from './Semantiq.tsx';
import X from './X.tsx';
import Xandr from './Xandr.tsx';
import Yaleo from './Yaleo.tsx';

export const BrandIcons = {
  AdConsole,
  Facebook,
  Gitlab,
  Google,
  Instagram,
  Linkedin,
  Meta,
  Microsoft,
  Passendo,
  Semantiq,
  X,
  Xandr,
  Yaleo,
};

export default BrandIcons;
